import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/logintest'
import home from '@/pages/home'
import test1 from '@/pages/test/test1'
import test2 from '@/pages/test/test2'
import index from '@/pages/index'
import message from '@/pages/message'
import vip from '@/pages/vip'
import permissionManagement from '@/pages/permission/permissionManagement'
import certificate from '@/pages/performance/certificate'
import trajectory from '@/pages/performance/trajectory'
import userinfo from '@/pages/performance/userinfo'
import user from '@/pages/performance/user'
import personAssess from '@/pages/performance/personAssess'
import personConRate from '@/pages/performance/personConRate'
import teamAssess from '@/pages/performance/teamAssess'
import teamConRate from '@/pages/performance/teamConRate'
import getPolicyList from '@/pages/policy/getPolicyList'
import getPolicyDetails from '@/pages/policy/getPolicyDetails'
import teamInfo from '@/pages/performance/teamInfo'
import myIncome from '@/pages/performance/myIncome'
import exam from './exam'
import backend from './backend'
import getContents from '@/pages/contents/contentControl'
// import ActivityHome from '@/pages/ActivityHome'
import Activitycount from '@/pages/Activitycount/Activitycount'
import Activitypeople from '@/pages/Activitycount/Activitypeople'
import MsgHome from '@/pages/MsgHome'
import msgList from '@/pages/msg/Msglist'
import detail from '@/pages/msg/detail'
import proList from '@/pages/proList'
import shortcutMenu from '@/pages/shortcutMenu'
import speakingMeetingHome from '@/pages/speakMeeting/speakMeetingHome'
import clientConsult from '@/pages/client/consult'
import ConsultDetail from '@/pages/client/consultDetail'
import OperationList from '@/pages/client/operationList'
import OperationDetail from '@/pages/client/operationDetail'
// import teamRate from '@/pages/team/teamRate'
import auth from '@/pages/auth'
import performanceReportManagement from '@/pages/performance/performanceReportManagement'
import ESGadministration from '@/pages/performance/ESGadministration'
import ESGAdd from '@/pages/performance/ESGAdd'
import ESGExampleShow from '@/pages/performance/ESGExampleShow'
import orderManagement from '@/pages/performance/orderManagement'
import orderInfo from '@/pages/performance/orderInfo'
// 证件核实
import checkCard1 from '@/pages/checkCard/list1'
import checkCard1Detail from '@/pages/checkCard/detail'
import checkCard2 from '@/pages/checkCard/list2'
import checkCard3 from '@/pages/checkCard/list3'
//通用保全
import pendingList from '@/pages/infoCollection/pendingList'
import processed from '@/pages/infoCollection/processed'
// 电子银保入司-入司管理
import electronInductionManagement from '@/pages/electronInduction/electronInductionManagement'
import privacyPolicy from '@/pages/privacyPolicy'

// 人员信息清单-机构内勤管理
import officeSaff from '@/pages/recruit/officeSaff/list'
// 机构负责人确认
import orgLeader from '@/pages/recruit/officeSaff/list' // /orgLeader/list
// 分公司审核
import branchOffice from '@/pages/recruit/officeSaff/list' //   /branchOffice/list
// 总公司
import headOffice from '@/pages/recruit/officeSaff/list' //    /headOffice/list

// 招募数据看板
import dataBoard from '@/pages/recruit/dataBoard'
//招募内勤用户维护
import userManagement from '@/pages/recruit/userManagement/list'
//性向测试结果
import aptitudeTest from '@/pages/recruit/aptitudeTest/list'
// 候选人画像
import candidatePortrait from '@/pages/recruit/candidatePortrait/list'
// 工作计划查询
import workPlanQuery from '@/pages/workPlanQuery/index'

Vue.use(Router)
let routes = [
  {
    path: '/home',
    name: 'home',
    component: home,
    children: [
      {
        path: '/precollected',
        component: () => import('@/pages/performance/precollected/precollectedHome'),
        redirect: '/precollected/precollectedSearch',
        name: 'precollectedHome',
        meta: {
          title: '预收',
          auth: false
        },
        children: [
          {
            path: 'precollectedSearch',
            component: () => import('@/pages/performance/precollected/precollectedEnquiry'),
            name: 'precollectedSearch',
            meta: {title: '预收查询'}
          },
          {
            path: 'precollectedStatistics',
            component: () => import('@/pages/performance/precollected/precollectedStatistics'),
            name: 'precollectedStatistics',
            meta: {title: '预收统计'}
          },
          {
            path: 'estimate',
            component: () => import('@/pages/performance/precollected/estimate'),
            name: 'estimate',
            meta: {title: '承保预估'}
          }
        ]
      },
      {
        path: '/honor',
        component: () => import('@/pages/honor/honorHome'),
        redirect: '/honor/honorNameManage',
        name: 'honor',
        meta: {
          title: '荣誉体系管理',
          auth: false
        },
        children: [
          {
            path: 'honorNameManage',
            component: () => import('@/pages/honor/honorNameManage'),
            name: 'honorNameManage',
            meta: {title: '荣誉名称和标准维护'}
          },
          {
            path: 'yearHonor',
            component: () => import('@/pages/honor/yearHonor'),
            name: 'yearHonor',
            meta: {title: '年度荣誉业绩维护'}
          },
          {
            path: 'monthHonor',
            component: () => import('@/pages/honor/monthHonor'),
            name: 'monthHonor',
            meta: {title: '月度荣誉业绩维护'}
          },
          {
            path: 'historyYearHonor',
            component: () => import('@/pages/honor/historyYearHonor'),
            name: 'historyYearHonor',
            meta: {title: '历史年度荣誉维护'}
          },
          {
            path: 'historyMonthHonor',
            component: () => import('@/pages/honor/historyMonthHonor'),
            name: 'historyMonthHonor',
            meta: {title: '历史月度荣誉维护'}
          },
        ]
      },
      {
        path: '/renewal',
        component: () => import('@/pages/performance/renewal/renewalHome'),
        redirect: '/renewal/orphanAcceptance',
        name: 'renewalHome',
        meta: {
          title: '续期',
          auth: false
        },
        children: [
          {
            path: 'orphanAcceptance',
            component: () => import('@/pages/performance/renewal/orphanAcceptance'),
            name: 'orphanAcceptance',
            meta: {title: '孤儿单接收'}
          },
          {
            path: 'renewalReductionEnquiry',
            component: () => import('@/pages/performance/renewal/renewalReductionEnquiry'),
            name: 'renewalReductionEnquiry',
            meta: {title: '续期扣款查询'}
          }
        ]
      },
      {
        path: '/home/myIncome',
        name: 'myIncome',
        component: myIncome
      },
      // {
      //   path: '/geCustomerManageDetail',
      //   name: 'getCustomerManageDetail',
      //   component: () => import('@/pages/customerManage/getCustomerManageDetail')
      // },
      // {
      //   path: '/getCustomerManageList',
      //   name: 'getCustomerManageList',
      //   component: () => import('@/pages/customerManage/getCustomerManageList')
      // },
      {
        path: '/orderManagement',
        name: 'orderManagement',
        component: orderManagement,
        meta: {
          title: '订单管理'
        }
      },
      {
        path: '/orderInfo',
        name: 'orderInfo',
        component: orderInfo,
        meta: {
          title: '查看订单详情'
        }
      },
      {
        path: '/getPolicyDetails',
        name: 'getPolicyDetails',
        component: getPolicyDetails
      },
      {
        path: '/getPolicyList',
        name: 'getPolicyList',
        component: getPolicyList
      },
      {
        path: '/test1',
        name: 'test1',
        component: test1
      },
      {
        path: '/test2',
        name: 'test2',
        component: test2
      },
      {
        path: '/home/personConRate',
        name: 'personConRate',
        component: personConRate
      },
      {
        path: '/home/userinfo',
        name: 'userinfo',
        component: userinfo
      },
      {
        path: '/home/user',
        name: 'user',
        component: user,
        meta: {auth: true}
      },
      {
        path: '/home/vip',
        name: 'vip',
        component: vip,
        meta: {auth: true}
      },
      {
        path: '/home/auth',
        name: 'auth',
        component: auth,
        meta: {auth: true}
      },
      {
        path: '/home/personAssess',
        name: 'personAssess',
        component: personAssess
      },
      {
        path: '/teamAssess',
        name: 'teamAssess',
        component: teamAssess
      },
      {
        path: '/home/certificate',
        name: 'certificate',
        component: certificate
      },
      {
        path: '/home/trajectory',
        name: 'trajectory',
        component: trajectory
      },
      {
        path: '/teamConRate',
        name: 'teamConRate',
        component: teamConRate,
        meta: {auth: false}
      },
      {
        path: '/home/teamInfo',
        name: 'teamInfo',
        component: teamInfo
      },
      {
        path: '/performanceReportManagement',
        name: 'performanceReportManagement',
        component: performanceReportManagement
      },
      {
        path: '/ESGadministration',
        name: 'ESGadministration',
        component: ESGadministration
      },
      {
        path: '/ESGAdd',
        name: 'ESGAdd',
        component: ESGAdd
      },
      {
        path: '/ESGExampleShow',
        name: 'ESGExampleShow',
        component: ESGExampleShow
      },
      {
        path: '/home/index',
        name: 'index',
        component: index,
        meta: {auth: true}
      },
      {
        path: '/home/message',
        name: 'message',
        component: message,
        meta: {auth: true}
      },
      {
        path: '/home/proList',
        name: 'proList',
        component: proList,
        meta: {auth: true}
      },
      {
        path: '/home/getContents',
        name: 'getContents',
        component: getContents,
        meta: {auth: true}
      },
      {
        path: '/home/shortcutMenu',
        name: 'shortcutMenu',
        component: shortcutMenu,
        meta: {auth: true}
      },
      {
        path: '/home/Activitycount',
        name: 'Activitycount',
        component: Activitycount,
        meta: {auth: true}
      },
      {
        path: '/home/Activitypeople',
        name: 'Activitypeople',
        component: Activitypeople,
        meta: {auth: true}
      },
      {
        path: '/home/workPlanQuery',
        name: 'workPlanQuery',
        component: workPlanQuery,
        meta: {auth: true}
      },
      {
        path: '/client/consult',
        name: 'clientConsult',
        component: clientConsult,
        props: {name: '我的咨询'},
        meta: {auth: true}
      },
      {
        path: '/client/consultDetail',
        name: 'ConsultDetail',
        component: ConsultDetail,
        props: {name: '咨询详情'},
        meta: {auth: true}
      },
      {
        path: '/operationList',
        name: 'OperationList',
        component: OperationList,
        props: {name: '运维列表'},
        meta: {auth: true}
      },
      {
        path: '/operationDetail',
        name: 'OperationDetail',
        component: OperationDetail,
        props: {name: '运维详情'},
        meta: {auth: true}
      },
      // {
      //   path: '/teamRate',
      //   name: 'teamRate',
      //   component: teamRate,
      //   props: { name: '经代公司继续率' },
      //   meta: { auth: true }
      // },
      // {
      //   path: '/home/ActivityHome',
      //   name: 'ActivityHome',
      //   component: ActivityHome,
      //   children: [
      //     {
      //       path: '/home/Activitycount',
      //       name: 'Activitycount',
      //       component: Activitycount,
      //       meta: {auth: true}
      //     },
      //     {
      //       path: '/home/Activitypeople',
      //       name: 'Activitypeople',
      //       component: Activitypeople,
      //       meta: {auth: true}
      //     }
      //   ]
      // },
      // {
      //   path: '/home/msgList',
      //   name: 'msgList',
      //   component: msgList,
      //   meta: {auth: true}
      // },
      {
        path: '/home/speaking',
        component: speakingMeetingHome,
        redirect: '/home/speaking/management',
        name: 'speakingMeetingHome',
        meta: {
          title: '创说会'
        },
        children: [
          {
            path: 'management',
            component: () => import('@/pages/speakMeeting/speakMeetingManagement/index'),
            redirect: '/home/speaking/management/businessExplanation',
            meta: {title: '活动管理', keepAlive: true},
            children: [
              {
                path: 'businessExplanation',
                component: () => import('@/pages/speakMeeting/speakMeetingManagement/businessExplanation'),
                name: 'businessExplanation',
                meta: {title: '活动管理', keepAlive: true}
              },
              {
                path: 'createActivity',
                component: () => import('@/pages/speakMeeting/speakMeetingManagement/createActivity/index'),
                name: 'createActivity',
                redirect: '/home/speaking/management/createActivity/createActivityBaseInfo',
                meta: {title: '创建活动', keepAlive: false},
                children: [
                  {
                    path: 'createActivityBaseInfo',
                    component: () => import('@/pages/speakMeeting/speakMeetingManagement/createActivity/createActivityBaseInfo'),
                    name: 'createActivityBaseInfo',
                    meta: {title: '基础信息', keepAlive: false}
                  },
                  {
                    path: 'createActivityInvitation',
                    component: () => import('@/pages/speakMeeting/speakMeetingManagement/createActivity/createActivityInvitation'),
                    name: 'createActivityInvitation',
                    meta: {title: '邀请函', keepAlive: false}
                  },
                  {
                    path: 'createActivitySetting',
                    component: () => import('@/pages/speakMeeting/speakMeetingManagement/createActivity/createActivitySetting'),
                    name: 'createActivitySetting',
                    meta: {title: '中奖配置', keepAlive: false}
                  }
                ]
              },
              {
                path: 'fieldWork',
                component: () => import('@/pages/speakMeeting/speakMeetingManagement/fieldWork'),
                name: 'fieldWork',
                meta: {title: '参会外勤', keepAlive: false}
              },
              {
                path: 'meetingUser',
                component: () => import('@/pages/speakMeeting/speakMeetingManagement/meetingUser'),
                name: 'meetingUser',
                meta: {title: '参会用户', keepAlive: false}
              },
              {
                path: 'getPrizeDetail',
                component: () => import('@/pages/speakMeeting/speakMeetingManagement/getPrizeDetail'),
                name: 'getPrizeDetail',
                meta: {title: '中奖名单', keepAlive: false}
              },
              {
                path: 'activityPrize',
                component: () => import('@/pages/speakMeeting/speakMeetingManagement/activityPrize'),
                name: 'activityPrize',
                meta: {title: '活动开奖', keepAlive: false}
              },
              {
                path: 'activityImg',
                component: () => import('@/pages/speakMeeting/speakMeetingManagement/activityImg'),
                name: 'activityImg',
                meta: {title: '活动图片', keepAlive: false}
              }
            ]
          },
          {
            path: 'luckDrawSetting',
            component: () => import('@/pages/speakMeeting/spaekMeetingRewardConfig/luckDrawSetting'),
            name: 'luckDrawSetting',
            meta: {title: '抽奖配置', keepAlive: false}
          },
          {
            path: 'spaekMeetingCount',
            component: () => import('@/pages/speakMeeting/spaekMeetingCount/index'), // Parent router-view
            redirect: '/home/speaking/spaekMeetingCount/mechanismStatistics',
            name: 'spaekMeetingCount',
            meta: {title: '活动统计', keepAlive: false},
            children: [
              {
                path: 'mechanismStatistics',
                component: () => import('@/pages/speakMeeting/spaekMeetingCount/mechanismStatistics'),
                name: 'mechanismStatistics',
                meta: {title: '机构统计', keepAlive: false}
              },
              {
                path: 'activityStatistics',
                component: () => import('@/pages/speakMeeting/spaekMeetingCount/activityStatistics'),
                name: 'activityStatistics',
                meta: {title: '活动统计', keepAlive: false}
              },
              {
                path: 'salesmanStatistics',
                component: () => import('@/pages/speakMeeting/spaekMeetingCount/salesmanStatistics'),
                name: 'salesmanStatistics',
                meta: {title: '业务员统计', keepAlive: false}
              },
              {
                path: 'salesmanDetails',
                component: () => import('@/pages/speakMeeting/spaekMeetingCount/salesmanDetails'),
                name: 'salesmanDetails',
                meta: {title: '业务员明细', keepAlive: false}
              },
              {
                path: 'participant',
                component: () => import('@/pages/speakMeeting/spaekMeetingCount/participant'),
                name: 'participant',
                meta: {title: '参与人员', keepAlive: false}
              }
            ]
          }
        ]
      },
      {
        path: '/home/MsgHome',
        name: 'MsgHome',
        component: MsgHome,
        children: [
          {
            path: '/home/msgList',
            name: 'msgList',
            component: msgList,
            meta: {auth: true}
          }
        ]
      },
      {
        path: '/home/detail',
        name: 'detail',
        component: detail,
        meta: {auth: true}
      },
      {
        path: '/checkCard1',
        name: 'checkCard1',
        component: checkCard1,
        meta: {auth: true,title: '到期客户明细'},
      },
      {
        path: '/checkCard1Detail',
        name: 'checkCard1Detail',
        component: checkCard1Detail,
        meta: {auth: true,title: '到期客户明细'},
      },
      {
        path: '/checkCard2',
        name: 'checkCard2',
        component: checkCard2,
        meta: {auth: true,title: '销售人员更新汇总'},
      },
      {
        path: '/checkCard3',
        name: 'checkCard3',
        component: checkCard3,
        meta: {auth: true,title: '汇总统计'},
      },
      {
        path: '/pendingList',
        name: 'pendingList',
        component: pendingList,
        meta: {auth: true,title: '待处理列表'},
      },
      {
        path: '/processed',
        name: 'processed',
        component: processed,
        meta: {auth: true,title: '已处理列表'},
      },
      {
        path: '/electronInductionManagement',
        name: 'electronInductionManagement',
        component: electronInductionManagement,
        meta: {auth: true,title: '入司管理'},
      },
      {
        path: '/recruit',
        component: () => import('@/pages/recruit/home'),
        redirect: '/recruit/dataBoard',
        name: 'recruit',
        meta: {
          title: '个险招募',
          auth: false
        },
        children: [
          {
            path: 'dataBoard',
            name: 'dataBoard',
            component: () => import('@/pages/recruit/dataBoard'),
            meta: {title: '数据看板'}, 
          },
          {
            path: 'officeSaff',
            name: 'officeSaff',
            component: () => import('@/pages/recruit/officeSaff/list'),
            meta: {title: '人员信息清单'},
          },
          {
            path: 'orgLeader',
            name: 'orgLeader',
            component: () => import('@/pages/recruit/officeSaff/list'),
            meta: {title: '机构负责人确认'},
          },
          {
            path: 'branchOffice',
            name: 'branchOffice',
            component: () => import('@/pages/recruit/officeSaff/list'),
            meta: {title: '分公司审核'},
          },
          {
            path: 'headOffice',
            name: 'headOffice',
            component: () => import('@/pages/recruit/officeSaff/list'),
            meta: {title: '总公司招募管理'},
          },
          {
            path: 'userManagement',
            name: 'userManagement',
            component: () => import('@/pages/recruit/userManagement/list'),
            meta: {title: '内勤用户维护'},
          }, 
          {
            path: 'aptitudeTest',
            name: 'aptitudeTest',
            component: () => import('@/pages/recruit/aptitudeTest/list'),
            meta: {title: '性向测试结果'},
          },
          {
            path: 'candidatePortrait',
            name: 'candidatePortrait',
            component: () => import('@/pages/recruit/candidatePortrait/list'),
            meta: {title: '候选人画像模型'},
          }
        ]
      }
    ]
  },
  // {
  //   path: '/',
  //   name: 'login',
  //   component: login
  // },
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/permissionManagement',
    name: 'permissionManagement',
    component: permissionManagement
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: privacyPolicy,
  },
]

routes = routes.concat(exam)
routes = routes.concat(backend)

export default new Router({
  routes: routes,
  watch: {
    $route: function (to, from) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js